/*
 * <color-swatch-picker>
 *
 * Progressive enhancement for the colour swatch row rendered by
 * snippets/color-swatch-picker.liquid.
 *
 * Each swatch is a real <a href> to a separate colourway product, so with JS
 * disabled the links navigate normally. When JS is available we intercept the
 * click and swap the main product section in place using the Section Rendering
 * API, then update the address bar to the selected product's URL.
 */
if (!customElements.get('color-swatch-picker')) {
  customElements.define(
    'color-swatch-picker',
    class ColorSwatchPicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const swatch = event.target.closest('a.color-swatch');
        // Ignore clicks that aren't on a clickable swatch inside this picker.
        if (!swatch || !this.contains(swatch)) return;
        // Let modifier/middle clicks open in a new tab as usual.
        if (event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        this.swap(swatch.href);
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      async swap(url) {
        const sectionId = this.sectionId;
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (!section || !url) {
          window.location.href = url;
          return;
        }

        this.setAttribute('aria-busy', 'true');

        try {
          const separator = url.indexOf('?') === -1 ? '?' : '&';
          const response = await fetch(`${url}${separator}section_id=${encodeURIComponent(sectionId)}`);
          if (!response.ok) throw new Error(`Section request failed: ${response.status}`);

          const text = await response.text();
          const newDocument = new DOMParser().parseFromString(text, 'text/html');
          // The Section Rendering API response may or may not include the
          // wrapping .shopify-section element; handle both shapes.
          const newSection =
            newDocument.getElementById(`shopify-section-${sectionId}`) ||
            newDocument.querySelector('.shopify-section') ||
            newDocument.body;

          if (!newSection) throw new Error('Section markup not found in response');

          section.innerHTML = newSection.innerHTML;

          // Keep canonical URLs, SEO and share/refresh correct.
          window.history.replaceState({}, '', url);

          const newHeading = section.querySelector('.product__title');
          if (newHeading) document.title = newHeading.textContent.trim();

          // Move focus to the newly selected swatch so assistive tech announces
          // the change.
          const activeSwatch = section.querySelector('.color-swatch--current');
          if (activeSwatch) activeSwatch.focus();

          document.dispatchEvent(new CustomEvent('color-swatch:swapped', { detail: { url } }));
        } catch (error) {
          console.error('[color-swatch-picker]', error);
          // Fall back to a normal navigation so the customer still reaches the product.
          window.location.href = url;
        }
      }
    }
  );
}
